export default __webpack_public_path__ + "static/media/solution.2dfaf6ec.png";